var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21134_65693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6641 9.33333C10.6641 10.7478 11.226 12.1044 12.2262 13.1046C13.2264 14.1048 14.5829 14.6667 15.9974 14.6667C17.4119 14.6667 18.7684 14.1048 19.7686 13.1046C20.7688 12.1044 21.3307 10.7478 21.3307 9.33333C21.3307 7.91885 20.7688 6.56229 19.7686 5.5621C18.7684 4.5619 17.4119 4 15.9974 4C14.5829 4 13.2264 4.5619 12.2262 5.5621C11.226 6.56229 10.6641 7.91885 10.6641 9.33333Z",
    stroke: "#1650FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 28V25.3333C8 23.9188 8.5619 22.5623 9.5621 21.5621C10.5623 20.5619 11.9188 20 13.3333 20H18.6667C20.0812 20 21.4377 20.5619 22.4379 21.5621C23.4381 22.5623 24 23.9188 24 25.3333V28",
    stroke: "#1650FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21134_65693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.dcb50e181d8c64158f4141060d0ffd96.svg";
export { ForwardRef as ReactComponent };